/**
 * 客户端调试记录器单例。
 *  - `APP_VERSION` 由 vite `define` 注入（源自 package.json）。
 *    `__APP_VERSION__` 的全局声明统一在 `src/vite-env.d.ts`（唯一 ambient 声明处）。
 *  - `logger` 为 app 主信道；`netLogger` 为**网络模式信道**（联机落地后专用）。
 */
import { createLogger, type Logger } from '@shared/debug/logger';

/** 编译期注入的版本号；裸环境（如单测）下回退 '0.0.0'。 */
export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';

export const logger: Logger = createLogger({
  service: 'marble-client',
  version: APP_VERSION,
  instance: 'local',
  level: 'debug',
});

/** 网络模式日志信道（预留）。 */
export const netLogger: Logger = logger.channelOf('net');
